import axios from 'axios';

const base = 'enlaces';

function getDashboard(data) {
    return axios.post(`${base}/dashboard`, data);
}

function getUsuariosEnlaces() {
    return axios.get(`${base}/dashboard/usuarios`);
}

const AnaliticaEnlacesService = {
    getDashboard,
    getUsuariosEnlaces,
};

export default AnaliticaEnlacesService;
